import Container from '../../ui-kit/components/wrappers/Container'
import UserAvatar from '../../ui-kit/components/atoms/UserAvatar'
import {CAMERA_ICON} from '../../ui-kit/helpers/icons/camera'
import {CLIP_ICON} from '../../ui-kit/helpers/icons/clip'
import PublicationImages from '../molecules/PublicationImages'
import ActionButtonFile from '../../ui-kit/components/atoms/buttons/ActionButtonFile'
import PublicationFiles from '../molecules/PublicationFiles'

const PublicationForm = () => {
  return (
    <Container className="publication-form">
      <form className="form">
        <div className="input-container">
          <UserAvatar className="big" />
          <div>
            <div
              className="input"
              contentEditable
              data-placeholder="¿Qué te gustaría publicar?"
            />
            {/* Acá van las imágenes o los archivos de la publicación */}
            {/*<PublicationImages
              editMode
              images={[
                'https://images.pexels.com/photos/261679/pexels-photo-261679.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
                'https://images.pexels.com/photos/357514/pexels-photo-357514.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
              ]}
            />*/}
            {/*<PublicationFiles
              editMode
              files={[
                'https://pepa.holla.cz/wp-content/uploads/2016/10/Go-in-Action.pdf',
                'https://pepa.holla.cz/wp-content/uploads/2016/10/Go-in-Action.pdf',
              ]}
            />*/}
          </div>
        </div>
        <footer className="footer">
          <ActionButtonFile
            format="image/*"
            onClick={() => {}}
            icon={CAMERA_ICON}
            title="Subir imagen"
          />
          <ActionButtonFile
            format=".pdf"
            onClick={() => {}}
            icon={CLIP_ICON}
            title="Subir archivo PDF"
          />
          <div className="separator" />
          <button className="button small" disabled>
            Publicar
          </button>
        </footer>
      </form>
    </Container>
  )
}

PublicationForm.propTypes = {}

export default PublicationForm
